import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const addons = Loadable(() => import('../../containers/web/addons'));
export default MapTo('vcg/components/soe-home/react/addons')(addons);
